import { Play } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import video1 from "@/assets/videos/neil-video-1.mp4";
import video2 from "@/assets/videos/neil-video-2.mov";
import video3 from "@/assets/videos/neil-video-3.mp4";
import video4 from "@/assets/videos/neil-video-4.mov";
import video5Asset from "@/assets/videos/neil-video-5.mp4.asset.json";

const videos = [
  { src: video5Asset.url, title: "Robots in Action", description: "See Neil AI's PUDU robotics fleet deployed in real-world operations." },
  { src: video1, title: "AI Automation in Action", description: "Intelligent workflows that reduce burnout and free up staff." },
  { src: video2, title: "Robotics Deployment", description: "PUDU service robots integrating seamlessly into daily operations." },
  { src: video3, title: "Enterprise Operations", description: "Scaling smarter with AI-powered business infrastructure." },
  { src: video4, title: "Workforce Empowerment", description: "Supporting teams — not replacing them — with automation." },
];

const Videos = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Videos — Neil AI Robotics & Automation in Action"
        description="Watch Neil AI Global Solutions deploy PUDU robotics and AI automation across restaurants, hotels, warehouses, healthcare, and more."
        canonical="https://www.neilai.ai/videos"
      />
      <Navigation />

      <main className="pt-32 md:pt-40 pb-20 px-4 md:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary/30 bg-primary/5 mb-4">
            <Play className="h-3.5 w-3.5 text-primary" />
            <span className="text-xs uppercase tracking-widest font-semibold text-primary">
              Video Library
            </span>
          </div>
          <h1 className="font-orbitron font-bold text-4xl md:text-6xl mb-4">
            Robots & AI <span className="text-primary">In Action</span>
          </h1>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">
            Cinematic looks at Neil AI's robotics deployments and AI automation systems
            transforming real businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {videos.map((v, i) => (
            <article
              key={i}
              className="group relative rounded-2xl overflow-hidden glass-effect border border-[hsl(var(--line))] hover:border-primary/50 transition-all duration-500 shadow-[0_0_40px_hsl(var(--primary)/0.1)] hover:shadow-[0_0_60px_hsl(var(--primary)/0.3)]"
            >
              <video
                src={v.src}
                controls
                loop
                muted
                playsInline
                preload="metadata"
                className="w-full h-auto aspect-video object-cover bg-black"
              />
              <div className="p-5 border-t border-[hsl(var(--line))]">
                <h2 className="font-semibold text-lg md:text-xl text-foreground mb-1">
                  {v.title}
                </h2>
                <p className="text-sm text-muted-foreground">{v.description}</p>
              </div>
            </article>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Videos;
